/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */

// Angular
import { NgModule } from '@angular/core';

// NGC Input Controls
import { NgcCheckBoxModule } from '../controls/checkbox/ngc-checkbox.component';
import { NgcComboBoxModule } from '../controls/combobox/ngc-combobox.component';
import { NgcDateTimeInputModule } from '../controls/datetimeinput/ngc-datetimeinput.component';
import { NgcDropDownListModule } from '../controls/dropdownlist/ngc-dropdownlist.component';
import { NgcInputModule } from '../controls/input/ngc-input.component';
import { NgcLabelInputModule } from '../controls/labelinput/ngc-labelinput.component';
import { NgcListBoxModule } from '../controls/listbox/ngc-listbox.component';
import { NgcMaskedInputModule } from '../controls/maskedinput/ngc-maskedinput.component';
import { NgcNumberInputModule } from '../controls/numberinput/ngc-numberinput.component';
import { NgcPasswordInputModule } from '../controls/passwordinput/ngc-passwordinput.component';
import { NgcTextAreaModule } from '../controls/textarea/ngc-textarea.component';

/**
 * NGC Input Module
 */
@NgModule({
    exports: [
        NgcCheckBoxModule,
        NgcComboBoxModule,
        NgcDateTimeInputModule,
        NgcDropDownListModule,
        NgcInputModule,
        NgcLabelInputModule,
        NgcListBoxModule,
        NgcMaskedInputModule,
        NgcNumberInputModule,
        NgcPasswordInputModule,
        NgcTextAreaModule
    ]
})
export class NgcInputsModule {
}